import { render, staticRenderFns } from "./WidgetOfferPreview.vue?vue&type=template&id=5f3146bc&scoped=true&"
import script from "./WidgetOfferPreview.vue?vue&type=script&lang=ts&"
export * from "./WidgetOfferPreview.vue?vue&type=script&lang=ts&"
import style0 from "./WidgetOfferPreview.vue?vue&type=style&index=0&id=5f3146bc&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3146bc",
  null
  
)

export default component.exports